module.exports = __webpack_public_path__ + "static/media/backgroundSFX.610272a3.mp3";